import {createStackNavigator} from '@react-navigation/stack';
import React from 'react';
import {TouchableOpacity} from 'react-native';
import config from '../config';
import I18n from '../lib/i18n';
import {ManageVouchers} from '../scenes';
import CardRegistrationIssueDuringSignUp from '../scenes/CardRegistrationIssue/CardRegistrationIssueDuringSignUp.container';
import LoginDuringSignUp from '../scenes/Login/LoginDuringSignUp.container';
import OtpVerification from '../scenes/Login/OtpVerification.container';
import ResetPassword from '../scenes/ResetPassword';
import * as SignUp from '../scenes/SignUp';
import {
  SuspendSuccess,
  TerminateSuccess,
} from '../scenes/SuspendSwapTerminateSuccess';
import {VoucherDetails} from '../scenes/Vouchers/VoucherDetails';
import theme from '../theme-config';
import {ConnectedStack} from './ConnectedStack';
import {LoginStackNavigator} from './LoginStackNavigator';
import {PortaOutStack} from './PortaOutStackNavigator';

const Stack = createStackNavigator();

const redirect = () =>
  config.WEB_HEADER_LOGO_REDIRECTION_URL &&
  document.location.assign(config.WEB_HEADER_LOGO_REDIRECTION_URL);
const Logo = () => (
  <TouchableOpacity onPress={redirect}>
    <img
      src={theme.logoImage}
      style={{alignSelf: 'flex-start', padding: 10}}
      height={36}
    />
  </TouchableOpacity>
);

export const RootStackNavigator = ({initialRouteName}) => {
  return (
    <Stack.Navigator
      initialRouteName={initialRouteName}
      screenOptions={{
        headerShown: false,
        title: null,
      }}>
      <Stack.Screen name="resetPassword" component={ResetPassword} />
      <Stack.Screen
        name="requiredToSignUp"
        component={SignUp.RequiredToSignUp}
      />
      <Stack.Screen
        name="choosePlan"
        component={SignUp.ChoosePlanDuringSignUp}
      />
      <Stack.Screen name="chooseNumber" component={SignUp.ChooseNumber} />
      <Stack.Screen name="chooseRegion" component={SignUp.ChooseRegion} />
      <Stack.Screen name="createAccount" component={SignUp.CreateAccount} />
      <Stack.Screen name="authDuringSignUp" component={LoginDuringSignUp} />
      <Stack.Screen name="otpVerification" component={OtpVerification} />
      <Stack.Screen name="validateEmail" component={SignUp.ValidateEmail} />
      <Stack.Screen
        name="RedirectToIdentityRequirementOrDashboard"
        component={SignUp.RedirectToIdentityRequirementOrDashboard}
      />
      <Stack.Screen name="deliveryAddress" component={SignUp.DeliveryAddress} />
      <Stack.Screen name="deliveryContact" component={SignUp.DeliveryContact} />
      <Stack.Screen name="deliveryMethod" component={SignUp.DeliveryMethod} />
      <Stack.Screen
        name="confirmPlan"
        component={SignUp.ConfirmPlanDuringOrderSim}
      />
      <Stack.Screen
        name="editPlanDuringSignUp"
        component={SignUp.EditPlanDuringSignUp}
        options={{headerLeft: null, gestureEnabled: false}}
      />
      <Stack.Screen
        name="registerPaymentDetails"
        component={SignUp.RegisterPaymentDetails}
      />
      <Stack.Screen
        name="payment"
        component={SignUp.Payment}
        options={({route}) => {
          if (route.params?.cannotGoBack) {
            return {
              headerLeft: null,
              gestureEnabled: false,
            };
          }
        }}
      />
      <Stack.Screen
        name="cardRegistrationIssueDuringSignUp"
        component={CardRegistrationIssueDuringSignUp}
      />
      <Stack.Screen
        name="identityRequirements"
        component={SignUp.IdentityRequirements}
      />
      <Stack.Screen name="passportCheck" component={SignUp.PassportCheck} />
      <Stack.Screen
        name="confirmPersonalInfo"
        component={SignUp.ConfirmPersonalInfo}
      />
      <Stack.Screen name="billingAddress" component={SignUp.BillingAddress} />
      <Stack.Screen name="wellDone" component={SignUp.WellDone} />

      <Stack.Screen
        name="friendInvitation"
        component={SignUp.FriendInvitation}
      />
      <Stack.Screen name="login" component={LoginStackNavigator} />
      <Stack.Screen
        name="portaOut"
        component={PortaOutStack}
        options={{
          cardStyle: {
            backgroundColor: theme.backgroundColor,
          },
        }}
      />
      <Stack.Screen
        name="connected"
        component={ConnectedStack}
        options={{
          headerShown: false,
        }}
      />
      <Stack.Screen
        name="suspendSuccess"
        component={SuspendSuccess}
        options={() => ({
          headerLeft: null,
          gestureEnabled: false,
          title: I18n.t('Dashboard.LostAndStolen.title'),
        })}
      />
      <Stack.Screen
        name="terminateSuccess"
        component={TerminateSuccess}
        options={() => ({
          headerLeft: null,
          gestureEnabled: false,
          title: I18n.t('Dashboard.LineTermination.title'),
        })}
      />
      <Stack.Screen
        name="manageVouchers"
        component={ManageVouchers}
        options={() => ({title: I18n.t('Dashboard.ManageVouchers.title')})}
      />
      <Stack.Screen
        name="voucherDetails"
        component={VoucherDetails}
        options={() => ({
          title: I18n.t('VoucherDetails.title'),
        })}
      />
      <Stack.Screen name="chooseSimOrEsim" component={SignUp.SimOrEsim} />
    </Stack.Navigator>
  );
};
